var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`${_vm.$appPrefix}-map`]},[_c('div',{ref:"map",class:[`${_vm.$appPrefix}-map`],style:({height: _vm.height, width: _vm.width})}),_c('input',{attrs:{"type":"hidden","name":_vm.name,"controls":true},domProps:{"value":_vm.fieldValue}})])
}
var staticRenderFns = []

export { render, staticRenderFns }